const { getElement } = window.BAO.Utils

const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class BeautyMediaGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setNavigationHeight()

    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.els.thumbnail.elements.forEach((thumbnail) => {
      this.listeners.add(thumbnail, 'click', this.onThumbClick.bind(this))
    })

    this.els.dot.elements.forEach((dot) => {
      this.listeners.add(dot, 'click', this.onDotClick.bind(this))
    })

    this.listeners.add(
      document,
      'refreshMediaGallery',
      this.setImages.bind(this),
    )

    this.setNavigationHeight = this.setNavigationHeight.bind(this)
    this.debouncedResize = window.BAO.Utils.debounce((e) => {
      this.setNavigationHeight()
    }, 50)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setNavigationHeight () {
    const slidesHeight = this.els.slides.element.offsetHeight

    this.els.navigation.element.style.setProperty(
      '--MarginBlockSize',
      `${slidesHeight}px`,
    )
  }

  initialiseCarousel () {
    const slideCount = this.els.slide.elements.length

    if (slideCount <= 1) return

    return new KeenSlider(
      this,
      {
        selector: '.prd-BeautyMedia_Slide:not(.prd-BeautyMedia_Slide-hidden)',
        centered: false,
        duration: 1000,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 0,
        },
        slideChanged: this.onSlideChanged.bind(this),
      },
      [setInitialised()],
    )
  }

  setImages () {
    const colour = getElement(
      '[data-variant-radios-el="option-choice"]:checked',
    )
    const colourName = colour.value.toLowerCase()

    if (!colour && !colourName) {
      return
    }

    let visibleImages = 0

    this.els.slide.elements.forEach((image) => {
      let hidden = image.dataset.colour !== colourName

      const slide = image.dataset.slide

      const thumb = document.querySelector(
        `.prd-BeautyMedia_Thumbnail[data-slide='${slide}']`,
      )
      const dot = document.querySelector(
        `.prd-BeautyMedia_Dot[data-slide='${slide}']`,
      )
      const zoomSlide = document.querySelector(
        `.prd-BeautyMediaZoom_Slide[data-slide='${slide}']`,
      )

      if (!image.hasAttribute('data-colour')) {
        hidden = false
      }

      image.classList.toggle('prd-BeautyMedia_Slide-hidden', hidden)
      thumb.classList.toggle('prd-BeautyMedia_Thumbnail-hidden', hidden)
      zoomSlide.classList.toggle('prd-BeautyMediaZoom_Slide-hidden', hidden)
      dot.classList.toggle('prd-BeautyMedia_Dot-hidden', hidden)

      if (!hidden) {
        image.dataset.index = visibleImages
        thumb.dataset.index = visibleImages
        dot.dataset.index = visibleImages
        visibleImages++
      } else {
        delete image.dataset.index
        delete thumb.dataset.index
        delete dot.dataset.index
      }
    })

    this.carousel.update(this.carousel.options, 0)
    this.carousel.track.init()

    this.els.thumbnail.elements.forEach((thumb) => {
      thumb.setAttribute(
        'aria-current',
        parseInt(thumb.dataset.index, 10) === 0,
      )
    })

    this.els.dot.elements.forEach((dot) => {
      dot.setAttribute('aria-current', parseInt(dot.dataset.index, 10) === 0)
    })
  }

  onThumbClick (e) {
    const thumbnailTrigger = e.target.closest(`${this.els.thumbnail.selector}`)

    const targetIndex = parseInt(thumbnailTrigger.dataset.index, 10)
    this.carousel.moveToIdx(targetIndex)
  }

  onDotClick (e) {
    const dotTrigger = e.target.closest(`${this.els.dot.selector}`)

    const targetIndex = parseInt(dotTrigger.dataset.index, 10)
    this.carousel.moveToIdx(targetIndex)
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.thumbnail.elements.forEach((thumb) => {
      thumb.setAttribute(
        'aria-current',
        parseInt(thumb.dataset.index, 10) === currentSlide,
      )
    })

    this.els.dot.elements.forEach((dot) => {
      dot.setAttribute(
        'aria-current',
        parseInt(dot.dataset.index, 10) === currentSlide,
      )
    })
  }
}

if (!customElements.get('beauty-media-gallery')) {
  customElements.define('beauty-media-gallery', BeautyMediaGallery)
}
